export default (item) => {
    return typeof item === `object` && item != null && !Array.isArray(item) && Object.keys(item).length === 0
}